// angular imports
import { 
    WritableSignal, 
    signal 
} from "@angular/core";

//local imports
import {  IBreadcrumbItemModel, ListItemFactory } from "@app/shared";
import { AbstractProgramModel } from "@app/catalog-common";
import { ProgramDto } from "@app/catalog";



export class ProgramModel extends AbstractProgramModel implements IBreadcrumbItemModel
{
    public thumbnailUrl: WritableSignal<string>;

    constructor()
    {
        super();
        this.thumbnailUrl = signal<string>(null);    
    }

    public static fromDto(dto: ProgramDto, isChecked: boolean = false)
    {
        let program = new ProgramModel();

        program.id = dto.id;
        program.name.set(dto.name);
        program.description.set(dto.name);
        program.thumbnailUrl.set(dto.thumbnailUrl);
        program.isActive.set(dto.isActive);
        program.isChecked.set(isChecked);
        return program;
    }

    public toListItem = (selected: boolean = false) => 
        ListItemFactory.create<ProgramModel>(this.name, this.id, this, selected);
    

    public toListItem$ = (selected: WritableSignal<boolean>) =>
        ListItemFactory.create$<ProgramModel>(this.name, this.id, this, selected);

}
